/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NewRoleOrgWithRoleAndUserPayloadModel model module.
 * @module model/NewRoleOrgWithRoleAndUserPayloadModel
 * @version v1.0.0
 */
class NewRoleOrgWithRoleAndUserPayloadModel {
    /**
     * Constructs a new <code>NewRoleOrgWithRoleAndUserPayloadModel</code>.
     * @alias module:model/NewRoleOrgWithRoleAndUserPayloadModel
     * @param newRoleId {Number} new role Id  (required)
     * @param organizationId {Number} organization Id  (required)
     * @param roleId {Number} role Id  (required)
     * @param userId {Number} user Id  (required)
     */
    constructor(newRoleId, organizationId, roleId, userId) { 
        
        NewRoleOrgWithRoleAndUserPayloadModel.initialize(this, newRoleId, organizationId, roleId, userId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, newRoleId, organizationId, roleId, userId) { 
        obj['newRoleId'] = newRoleId;
        obj['organizationId'] = organizationId;
        obj['roleId'] = roleId;
        obj['userId'] = userId;
    }

    /**
     * Constructs a <code>NewRoleOrgWithRoleAndUserPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NewRoleOrgWithRoleAndUserPayloadModel} obj Optional instance to populate.
     * @return {module:model/NewRoleOrgWithRoleAndUserPayloadModel} The populated <code>NewRoleOrgWithRoleAndUserPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NewRoleOrgWithRoleAndUserPayloadModel();

            if (data.hasOwnProperty('newRoleId')) {
                obj['newRoleId'] = ApiClient.convertToType(data['newRoleId'], 'Number');
            }
            if (data.hasOwnProperty('organizationId')) {
                obj['organizationId'] = ApiClient.convertToType(data['organizationId'], 'Number');
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ApiClient.convertToType(data['roleId'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * new role Id  (required)
 * @member {Number} newRoleId
 */
NewRoleOrgWithRoleAndUserPayloadModel.prototype['newRoleId'] = undefined;

/**
 * organization Id  (required)
 * @member {Number} organizationId
 */
NewRoleOrgWithRoleAndUserPayloadModel.prototype['organizationId'] = undefined;

/**
 * role Id  (required)
 * @member {Number} roleId
 */
NewRoleOrgWithRoleAndUserPayloadModel.prototype['roleId'] = undefined;

/**
 * user Id  (required)
 * @member {Number} userId
 */
NewRoleOrgWithRoleAndUserPayloadModel.prototype['userId'] = undefined;






export default NewRoleOrgWithRoleAndUserPayloadModel;

